export default "__VITE_ASSET__Cm0mIgjt__"